import { render } from "./index.vue?vue&type=template&id=3c3c5019"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c3c5019&lang=css"

import exportComponent from "C:\\work\\takeda\\ui\\takeda_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/module/setup/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c3c5019"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c3c5019', __exports__)) {
    console.log('reload')
    api.reload('3c3c5019', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3c3c5019", () => {
    console.log('re-render')
    api.rerender('3c3c5019', render)
  })

}


export default __exports__